import { render, staticRenderFns } from "./gui.vue?vue&type=template&id=0c3b61a7&scoped=true&"
import script from "./gui.vue?vue&type=script&lang=js&"
export * from "./gui.vue?vue&type=script&lang=js&"
import style0 from "./gui.vue?vue&type=style&index=0&id=0c3b61a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3b61a7",
  null
  
)

export default component.exports